<template>
  <div>
    <label class="control-label">Teams / members</label>
    <a
      href="#"
      class="pull-right select-all"
      @click.prevent="selectAllMembers"
    >
      Select all
    </a>
    <AppSelect
      class="select-auto_track_rule-user-ids"
      show-loading-state
      :value="value"
      :options="memberOptions"
      :select2-options="select2Options"
      @input="selectMember"
      @focusout="$emit('focusout')"
    />
  </div>
</template>

<script>
import AppSelect from '~/components/AppSelect.vue';
import { orderBy } from 'lodash-es';
import { isMobile } from '~/mixins';

export default {
  name: 'AutoTrackRulesMemberSelect',
  components: { AppSelect },
  mixins: [isMobile],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    members: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    select2Options: Object.freeze({
      allowClear: true,
      placeholder: 'Choose who this policy applies to',
      multiple: true,
      width: '100%',
    }),
  }),
  computed: {
    membersMap() {
      return new Map(this.members?.map((member) => [member.id, { ...member, text: member.name }]));
    },
    memberOptions() {
      return orderBy([...this.membersMap.values()], ['text']);
    },
  },
  methods: {
    selectAllMembers() {
      this.$emit('input', [...this.membersMap.keys()]);
      this.$emit('focusout');
    },
    selectMember(memberIds) {
      // Make sure we convert the `memberIds` to an array of integers
      const parsedMemberIds = memberIds?.map((mId) => parseInt(mId, 10)) ?? [];
      // Diff the `memberIds` with the current value
      const finalMemberIds = parsedMemberIds.filter((mId) => this.membersMap.has(mId));

      this.$emit('input', finalMemberIds);
    },
  },
};
</script>
